/**
 * Typed runtime config (frontend design §13.2). Feature code reads this instead
 * of touching `import.meta.env` directly, which keeps mocking trivial in tests.
 */

export interface AppConfig {
  /**
   * API base URL. Empty by default so requests are **relative** (`/api/...`):
   * locally Vite proxies them to :3001, in the cloud CloudFront routes `/api/*`
   * to API Gateway. Set `VITE_API_BASE_URL` only to point at another origin.
   */
  readonly apiBaseUrl: string;
  readonly appEnv: string;
  readonly buildVersion: string;
}

export function readConfig(): AppConfig {
  const env = import.meta.env;
  return {
    apiBaseUrl: env.VITE_API_BASE_URL ?? '',
    appEnv: env.VITE_APP_ENV ?? 'local',
    buildVersion: env.VITE_BUILD_VERSION ?? 'dev',
  };
}

export function useConfig(): AppConfig {
  return readConfig();
}
